export const routeConfig = {
  meta: {
    title: '申请融资',
  },
  redirect: '/financing/edit/editOne',
};
